import React from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"

export default function workSlider(){
    const settings = {
        dots:true,
        arrows:true,
		autoplay:true,
		autoplaySpeed:3000,
		slidesToShow: 2,
    	slidesToScroll: 1,
    }
    return(
        <div>
            <div className="slider_wrap">
                <Slider {...settings} className="slider">
                    <li className="work-img work_0 bg-img_cover" />
                    <li className="work-img work_1 bg-img_cover" />
                    <li className="work-img work_2 bg-img_cover" />
                    <li className="work-img work_3 bg-img_cover" />
                    <li className="work-img work_4 bg-img_cover" />
                    <li className="work-img work_5 bg-img_cover" />
                    <li className="work-img work_6 bg-img_cover" />
                    <li className="work-img work_7 bg-img_cover" />
                    <li className="work-img work_8 bg-img_cover" />
                    <li className="work-img work_9 bg-img_cover" />
                </Slider>
            </div>{/*.slider_wrap*/}
            <div className="slide-controller">
                <div className="gauge">
                    <div className="gauge_0"><div /></div>
                    <div className="gauge_1"><div /></div>
                    <div className="gauge_2"><div /></div>
                    <div className="gauge_3"><div /></div>
                    <div className="gauge_4"><div /></div>
                    <div className="gauge_5"><div /></div>
                    <div className="gauge_6"><div /></div>
                    <div className="gauge_7"><div /></div>
                    <div className="gauge_8"><div /></div>
                    <div className="gauge_9"><div /></div>
                </div>
            </div>{/*.slide-controller*/}
        </div>
    )
}